module.exports = __webpack_public_path__ + "img/inperson-type.af747d19.svg";